// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ProgramV1GetProgramDefaultResponseData {
    static getAttributeTypeMap() {
        return ProgramV1GetProgramDefaultResponseData.attributeTypeMap;
    }
}
ProgramV1GetProgramDefaultResponseData.discriminator = undefined;
ProgramV1GetProgramDefaultResponseData.additionalProperties = false;
ProgramV1GetProgramDefaultResponseData.attributeTypeMap = [
    {
        "name": "tenantId",
        "baseName": "tenantId",
        "type": "number"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "programType",
        "baseName": "programType",
        "type": "string"
    },
    {
        "name": "programName",
        "baseName": "programName",
        "type": "string"
    },
    {
        "name": "programNumber",
        "baseName": "programNumber",
        "type": "number"
    },
    {
        "name": "programDesc",
        "baseName": "programDesc",
        "type": "string"
    },
    {
        "name": "programStartDate",
        "baseName": "programStartDate",
        "type": "string"
    },
    {
        "name": "programEndDate",
        "baseName": "programEndDate",
        "type": "string"
    },
];
//# sourceMappingURL=programV1GetProgramDefaultResponseData.js.map